@if (!linkConfig.button) {
  <span
    #content
    class="link u-maxX"
    [ngClass]="{
      't-bold': linkConfig.bold,
      't-link': !linkConfig.removeLinkStyles,
    }"
    role="link"
    tabindex="0"
    (click)="
      linkConfig.useExternalSiteModal
        ? openModal($event)
        : handleLinkClick($event, linkConfig)
    "
    [dataNavEvent]="getLinkEvent()"
    [attr.aria-label]="'Link to ' + linkConfig.label"
  >
    <ng-content></ng-content>
  </span>
}
@if (linkConfig.button) {
  <zip-button
    (click)="
      linkConfig.useExternalSiteModal
        ? openModal($event)
        : handleLinkClick($event, linkConfig)
    "
    [config]="linkConfig.button"
  ></zip-button>
}

@if (externalSiteModalConfig) {
  <external-site-warning-modal
    [isModalOpen]="isModalOpen"
    [externalSiteModalConfig]="externalSiteModalConfig"
    [linkConfig]="linkConfig"
    (closeModalClicked)="closeModal()"
    (continueClicked)="handleLinkClick($event, linkConfig)"
  ></external-site-warning-modal>
}
